import InputLabel from "@mui/material/InputLabel";
import TextField from "@mui/material/TextField";
import { FC, useState } from "react";

type TextInputProps = {
  label: string;
  value: string;
  register: any;
  onChange?: () => void;
  labelStyle?: {};
  labelClassName?: string;
};

export const TextInput: FC<TextInputProps> = ({
  label,
  value,
  onChange,
  register,
  labelStyle,
  labelClassName
}) => {
  return (
    <div className="flex flex-row item items-center">
      {/* <InputLabel sx={labelStyle ?? { marginRight: "12px" }}>{label}</InputLabel> */}
      <label className={`font-bold mr-3 ${labelClassName ?? ""}`} style={labelStyle}>{label}</label>
      <TextField
        {...register}
        defaultValue={value}
        onChange={onChange}
        sx={{
          "& .MuiInputBase-input": {
            height: "5px",
          },
        }}
      />
    </div>
  );
};
